/*  eslint-disable */
import config from '../config/config';
import REST_API_NAMES from '../config/restApiNames';
import moment from 'moment-timezone';
import { callApi } from '../util/ApiUtil';

// https://enterprise-bitbucket.asurion.com/projects/AW/repos/att-onboarding/pull-requests/52/diff#src/onboarding/schedule/actions/scheduleAction.js
// https://stackoverflow.com/questions/46241827/fetch-api-requesting-multiple-get-requests

const doBookExperience = (payload) => {
  console.log('bookingPayload = ', payload);

  return Promise.all([_sendToV1(payload), _sendToCSDB(payload), _sendToVHT(payload)])
    .then((values) => {
      let v1Result = values[0],
        vhtResult = values[2],
        interactionId = vhtResult.status === 'success' ? vhtResult.response : null;

      if (v1Result.response === -1) {
        // show error dialog
      } else if (interactionId === 108019) {
        // show error dialog
      } else {
        var pl = {
          agent_json: {
            id: v1Result.response,
            customerSessionId: payload.customerSessionId,
            customerCallbackNumber: payload.customerCallbackNumber,
            subscriberMdn: payload.customerCallbackNumber,
            vhtID: interactionId ? interactionId : 'FAILED',
          },
        };

        // att onboarding requirement, tell backend that all api calls are done
        _sendId(pl).then((response) => {
          if (response.status === 'success') {
            return response;
          }
        });
      }
    })
    .catch((err) => {
      throw err;
    });
};

export default doBookExperience;

const _sendToV1 = (bookingPayload) => {
  return callApi({
    method: 'POST',
    url: config.REST_URL(REST_API_NAMES.createAppointment),
    headers: {
      'Content-Type': 'application/json',
    },
    retries: 2,
    body: JSON.stringify({
      agent_json: {
        agentAssignStatus: true,
        assignedAgentName: 'VHT',
        captchaResponse: bookingPayload.captchaResponse,
        channel: null,
        customerAppointmentDateTime: bookingPayload.customerAppointmentDateTime,
        customerAppointmentDescription: null,
        customerCallbackNumber: bookingPayload.customerCallbackNumber,
        customerEmailAddress: bookingPayload.customerEmailAddress,
        customerFirstName: bookingPayload.customerFirstName,
        customerLastName: bookingPayload.customerLastName,
        customerNewDeviceModel: null,
        customerOldDeviceModel: null,
        customerSessionId: bookingPayload.customerSessionId,
        endpointId: bookingPayload.distinctId,
        megaUseCase: bookingPayload.megaUseCase,
        messageId: bookingPayload.messageId,
        programId: null,
        repBrowserInfo: bookingPayload.repBrowserInfo,
        repDeviceInfo: bookingPayload.repDeviceInfo,
        sourceDomain: bookingPayload.sourceDomain,
        storeLocation: 'DestinationSite',
        storeName: 'DestinationSite',
        subscriberMdn: bookingPayload.customerCallbackNumber,

        timezone: bookingPayload.timezone,
        universalId: bookingPayload.atlasUniversalId,
        vhtSegmentId: bookingPayload.vhtSegment,
        vhtclientCode: 'ATT_MPC', // This is the code for MUC
        appointmentType: bookingPayload.appointmentType,
      },
    }),
  })
    .then((response) => {
      return { status: 'success', response: response };
    })
    .catch((err) => {
      //TODO: need to do a retry!
      const errObject = { status: 'failed', response: err };
      throw errObject;
    });
};

const _sendToCSDB = (data) => {
  const vhtClientcode = data.vhtclientCode || 'BMI'; // TODO: look on how vhtclientCode was set
  return callApi({
    method: 'POST',
    url: config.REST_URL(REST_API_NAMES.csdb),
    headers: {
      'Content-Type': 'application/json',
    },
    retries: 2,
    body: JSON.stringify({
      ChannelShareDataParameters: {
        MobileDeviceNumber: data.customerCallbackNumber,
        CallId: data.customerSessionId,
        Channel: 'ATTOnboarding',
        ChannelShareDataElements: {
          ChannelShareDataElement: [
            { Name: 'callbackMdn', Value: data.customerCallbackNumber },
            { Name: 'MDN', Value: data.customerCallbackNumber },
            {
              Name: 'attDeviceSetup',
              Value: data.vhtSegment.indexOf('ATT.en-us.Soluto_Mega') === -1,
            }, // mega use case will be set to false
            { Name: 'oldDeviceModel', Value: data.customerOldDeviceModel },
            { Name: 'newDeviceModel', Value: data.customerNewDeviceModel },
            { Name: 'firstName', Value: data.customerFirstName },
            { Name: 'lastName', Value: data.customerLastName },
            {
              Name: 'attRepName',
              Value: data.customerFirstName + ',' + data.customerLastName,
            },
            { Name: 'storeCity', Value: data.customerCity },
            {
              Name: 'description',
              Value: data.customerAppointmentDescription,
            },
            { Name: 'newDeviceMDN', Value: data.customerCallbackNumber },
            { Name: 'storeLocation', Value: data.storeLocation },
            { Name: 'ClientCode', Value: vhtClientcode },
            { Name: 'CTI_CLIENT', Value: 'BMI' },
            { Name: 'LANGUAGE', Value: 'en-US' },
            {
              Name: 'customerAppointmentDateTime',
              Value: moment(Number(data.customerAppointmentDateTime))
                .utc()
                .format(),
            },
          ],
        },
      },
    }),
  })
    .then((response) => {
      return { status: 'success', response: response };
    })
    .catch((err) => {
      //TODO: need to do a retry!
      const errObject = { status: 'failed', response: err };
      throw errObject;
    });
};

const _sendToVHT = (data) => {
  const callId = data.customerSessionId,
    customerAppointmentDateTime = moment(Number(data.customerAppointmentDateTime))
      .utc()
      .format(),
    formattedCallbackNumber = data.customerCallbackNumber.replace(/[- )(]/g, ''), // TODO: what is this for?
    vhtSegment = data.vhtSegment,
    payload = `<soapenv:Envelope
            xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/"
            xmlns:plat="http://www.virtualhold.com/Toolkit/Platform-v5">
            <soapenv:Header/>
            <soapenv:Body>
                <plat:AddInteraction>
                    <plat:data>
                        <plat:Tenant>Asurion</plat:Tenant>
                        <plat:Segment>${vhtSegment}</plat:Segment>
                        <plat:Contact>${formattedCallbackNumber}</plat:Contact>
                        <plat:Options>
                            <plat:AppointmentTime>${customerAppointmentDateTime}</plat:AppointmentTime>
                            <plat:UserData>
                                <plat:UserDataItem>
                                    <plat:Name>OLDCALLID</plat:Name>
                                    <plat:Value>${callId}</plat:Value>
                                    <plat:DataType>String</plat:DataType>
                                </plat:UserDataItem>
                            </plat:UserData>
                        </plat:Options>
                    </plat:data>
                </plat:AddInteraction>
            </soapenv:Body>
        </soapenv:Envelope>`;

  return callApi({
    method: 'POST',
    url: config.REST_URL(REST_API_NAMES.vhtAddAppointment),
    headers: {
      'Content-Type': 'application/json',
    },
    retries: 2,
    shouldRetry: (response) => {
      let code = _extractVhtResponseCode(_transformToXmlDoc(response)),
        failureCodes = [107010, 107011, 107012, 107015, 108019, 108037];

      if (failureCodes.indexOf(Number(code)) > -1 || code === 107014) {
        return 'VHT returns ' + code + ' would attempt to retry..';
      }
      return false;
    },
    body: JSON.stringify({ body: payload }),
  })
    .then((response) => {
      var xmlDoc = _transformToXmlDoc(response),
        code = _extractVhtResponseCode(xmlDoc);

      var failureCodes = [107010, 107011, 107012, 107015, 108019, 108037];
      if (failureCodes.indexOf(Number(code)) > -1) {
        let interactionId = null;
        if (Number(code) === 108019) {
          let interaction = xmlDoc.getElementsByTagName('Interaction');

          if (interaction.length > 0) {
            interactionId = interaction[0].getAttribute('Id');
          }
        }
        return interactionId;
      } else if (Number(code) === 107000) {
        var interactionId = null,
          interaction = xmlDoc.getElementsByTagName('Interaction');

        if (interaction.length > 0) {
          interactionId = interaction[0].getAttribute('Id');
        }

        return interactionId;
      } else {
        // TODO: DO A RETRY!
        //retry(code, "VHT error code thrown");
      }
    })
    .then((interactionId) => {
      return { status: 'success', response: interactionId };
    })
    .catch((err) => {
      //TODO: need to do a retry!
      return { status: 'failed', response: err };
    });
};

const _transformToXmlDoc = (response) => {
  const parser = new DOMParser();
  return parser.parseFromString(response, 'text/xml');
};

const _extractVhtResponseCode = (xmlDoc) => {
  const nodes = xmlDoc.getElementsByTagName('Code');
  return nodes && nodes.length > 0 ? nodes[0].childNodes[0].nodeValue : 'UNKNOWN';
};

const _sendId = (payload) => {
  return fetch(config.REST_URL(REST_API_NAMES.sendV1IdAndVhtId), {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .then((response) => {
      return { status: 'success', response: response };
    })
    .catch((err) => {
      //TODO: need to do a retry!
      return { status: 'failed', response: err };
    });
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/api/CallMeLater.js